import React from 'react';

import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { SidebarContent, SidebarMenu } from 'components/ui/sidebar';

import { TemplateStudioFooterForm } from './BlocksForms/Footer';
import { TemplateStudioHeaderForm } from './BlocksForms/Header';
import { FormsSeparator } from './Components/FormMenuSeparator';
import { TemplateStudioDraggableBlockForms } from './DraggableBlockForms';

export const MAIN_SIDEBAR_WIDTH = 318;

export const TemplateStudioMainSidebar: React.FC = () => {
  const { defaultBodyBlocksOrder } = useTemplateStudioState();

  return (
    <SidebarContent
      className={`tb-main-sidebar-content w-[${MAIN_SIDEBAR_WIDTH}px] max-w-[${MAIN_SIDEBAR_WIDTH}px] min-w-[${MAIN_SIDEBAR_WIDTH}px] h-full box-content`}
    >
      {defaultBodyBlocksOrder && (
        <SidebarMenu className="tb-main-sidebar-menu gap-0 pr-4">
          <TemplateStudioHeaderForm />
          <FormsSeparator />

          <TemplateStudioDraggableBlockForms
            defaultBodyBlocksOrder={defaultBodyBlocksOrder}
          />

          <TemplateStudioFooterForm />
        </SidebarMenu>
      )}
    </SidebarContent>
  );
};
